export enum BadgeVariant {
  subtle = 'subtle',
  solid = 'solid',
  outline = 'outline',
}

export type ColorScheme =
  | 'teal'
  | 'gray'
  | 'blue'
  | 'green'
  | 'yellow'
  | 'red'
  | 'brand'
  | 'neutral'
  | 'info'
  | 'success'
  | 'warning'
  | 'error'
  | 'highlight';
